<script>

  /**
   * @exports MTableHeaderMixin
   * @class MTableHeaderMixin
   * @requires MTableEvents
   */
  export default {
    name: 'MTableHeaderMixin',
    created () {
      if (this.registerHeaderEventsListener) {
        this.registerHeaderEventsListener('handle-click-header-hint', this.handleClickHeaderHint);
      }
    },
    destroyed () {
      if (this.unregisterHeaderEventsListener) {
        this.unregisterHeaderEventsListener('handle-click-header-hint', this.handleClickHeaderHint);
      }
    },
    methods: {
      handleClickHeaderHint (value) {
        this.$emit('handle-click-header-hint', value);
      }
    }
  };
</script>
